<div class="action-group mb-4">
  <div class="action-list flex-start">
    <div class="filter-tabs">
      <sp-navigation-tab-link [filterTabs]="filterTabs" [selectedTabKey]="selectedTabKey" (selectedTab)="tabSelected.emit($event)"> </sp-navigation-tab-link>
    </div>
  </div>
  <div class="action-list justify-end">
    <sp-search-field
      class="action-item"
      [maxWidth]="'400px'"
      (keyUpInput)="searchTextChanged.emit($event)"
      (clearInput)="clearSearch.emit($event)"
      [placeholder]="searchPlaceholder"
      (toggleMobileSearch)="toggleMobileSearch()"
      [searchText]="searchText"
    ></sp-search-field>
    <div class="filter-box relative">
      <button mat-flat-button type="button" class="filter-button button-primary" [matMenuTriggerFor]="filterMenu" #menuTrigger>
        <mat-icon class="material-icons-outlined">filter_alt</mat-icon>
        <span class="filter-label-wrapper">
          <span class="filter-label">Filter </span>
          <span class="filter-count" *ngIf="appliedFilters">({{ appliedFilters }})</span>
        </span>
      </button>
      <mat-menu #filterMenu="matMenu" class="custom-filter-popup-box">
        <ng-template matMenuContent>
          <sp-filter-forms [formData]="filterAssetFormData" [filterType]="'custom'" [selectedFilterObject]="selectedFilterObject" (clickApplyFilter)="filterAssets($event)"> </sp-filter-forms>
        </ng-template>
      </mat-menu>
    </div>
    <div class="action-item">
      <button mat-icon-button [matMenuTriggerFor]="gridMenu" *ngIf="!assetViewTypeService.getGridSettings('showListView', gridSettingsKeySuffix)">
        <mat-icon class="material-icons-outlined" matTooltip="Table setting">settings</mat-icon>
      </button>
      <mat-menu #gridMenu="matMenu">
        <ng-template matMenuContent>
          <sp-table-wheel-setting
            (changeView)="changeView.emit($event)"
            [headerType]="'assetGallery'"
            [menuObjects]="assetGalleryMenuObject"
            [selectedViewType]="assetViewTypeService.getViewType(gridSettingsKeySuffix)"
            [selectedViewSection2]="selectedViewSection2"
            (sortBy)="sortBy.emit($event)"
            [sortByNew]="sortByNew"
          ></sp-table-wheel-setting>
        </ng-template>
      </mat-menu>
    </div>
  </div>
</div>
<div class="mobile-search" [ngClass]="{ 'is-open': isMobileSearchOpen }" (window:resize)="onEvent()" (focusout)="onEvent()" tabindex="1">
  <sp-search-field
    [searchText]="searchText"
    [maxWidth]="''"
    (keyUpInput)="searchTextChanged.emit($event)"
    (clearInput)="clearSearch.emit($event)"
    [placeholder]="searchPlaceholder"
    [mobileSearch]="true"
  ></sp-search-field>
</div>
